export enum Priority {
  VeryHigh,
  High,
  Medium,
  Low,
  VeryLow
}
